import React from "react"
import manWoman from '../../images/man-woman.jpg'
import man3 from '../../images/man-3.jpg'
import man2 from '../../images/man-2.jpg'


const About = () => (
  <section className="py-20">
    <div className="container max-w-screen-lg mx-auto px-5">
      <div className="flex items-center mb-16 flex-col md:flex-row">
        <div className="mb-4 mr-0 md:mb-0 md:mr-16">
          <h2 className="text-3xl mb-3 font-heading">Antoni Wolf</h2>
          <p className="text-lg">Before Antoni wrote his first movie, his first job in the film industry was as a designer of frontispieces for 'silent movies' in the studio's of Famous Players-Lasky in Islington. Four years later he became scenarist for director Graham Cutts, and that's where he examined his possibilities as art-director and cutter. In 2011 he married script-girl Alma Reville, who closely collaborated with him all of his career.</p>
        </div>
        <div className="block bg-gray-300 text-gray-500 w-full md:w-4/12 flex-shrink-0">
          <img className="max-w-full w-full" src={man2} alt="Man" />
        </div>
      </div>
      <div className="flex items-center mb-16 flex-col md:flex-row">
        <div className="mb-4 mr-0 md:mb-0 md:mr-16">
          <h2 className="text-3xl mb-3 font-heading">Christopher Simmons</h2>
          <p className="text-lg">Charles Simmons, born on April 16 in London, England, is considered as the one of the greatest screenwriters the world has ever seen. He is not just a comedian, actor and a performer but also a thinker who had the power to realistically reflect and reasonably exaggerate contemporary issues that could draw people to witness and understand the issues through the film.</p>
        </div>
        <div className="block bg-gray-300 text-gray-500 w-full md:w-4/12 flex-shrink-0">
          <img className="max-w-full w-full" src={man3} alt="woman" />
        </div>
      </div>
      <div className="flex items-center flex-col md:flex-row">
        <div className="mb-4 mr-0 md:mb-0 md:mr-16">
          <h2 className="text-3xl mb-3 font-heading">Kathrine & Marcus Holmes</h2>
          <p className="text-lg">Many people like to watch the stories of love unfold in television soap operas. The soaps feature some of the most dramatic stories which are not usually reality but fiction. It is the everyday experiences of life that inspire the soaps which make for a great viewing. The main message in stories of love is that love triumphs or conquers every thing. It knows no boundaries and it will overcome all.</p>
        </div>
        <div className="block bg-gray-300 text-gray-500 w-full md:w-4/12 flex-shrink-0">
          <img className="max-w-full w-full" src={manWoman} alt="Man 2" />
        </div>
      </div>
    </div>
  </section>
)

export default About